import { importProvidersFrom, ApplicationConfig } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { ApSentryModule } from '@ap/sentry';
import { ApCookieConsentService } from '@ap/cookie-consent';
import { FALLBACK_PAGENAME } from '@ap/analytics';
import { ApPersistenceModule } from '@ap/persistence';
import { MijnAnalyseModule } from '@ap/mijn-analyse';
import { provideMijnAuthSessieManager } from '@ap/mijn-auth-sessie-manager';

import { MijnLoginRouterModule } from './mijn-login.router.module';

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(BrowserModule, ApPersistenceModule, MijnAnalyseModule, MijnLoginRouterModule, ApSentryModule),
        provideMijnAuthSessieManager(),

        { provide: FALLBACK_PAGENAME, useValue: '' },
        ApCookieConsentService
    ]
};
